import { Link } from './link'

export function Footer() {
  return (
    <footer className="border-t border-accent-6 bg-gray-2 dark:border-gray-6">
      <div className="container flex max-w-6xl flex-col gap-5 py-5">
        <div className="flex w-full items-center justify-center gap-3">
          <Link to="/" className="text-body-sm text-gray-11">
            Home
          </Link>
          <Link to="/about" className="text-body-sm text-gray-11">
            About
          </Link>
          <Link to="/contact" className="text-body-sm text-gray-11">
            Contact
          </Link>
          <Link to="/privacy" className="text-body-sm text-gray-11">
            Privacy
          </Link>
          <Link to="/login" className="text-body-sm text-gray-11">
            Login
          </Link>
        </div>
        <div className="flex w-full items-center justify-center">
          <p className="text-xs">&copy;{new Date().getFullYear()} capbuddy.org</p>
        </div>
      </div>
    </footer>
  )
}
